import React from 'react';
import { Button, Drawer, Space } from 'antd';
import { updateURLParamsSilently } from '@utils/urlParams';
import {
  METADATA_FILTERS_APPLY_LABEL,
  METADATA_FILTERS_CLEAR_ALL_LABEL,
  METADATA_FILTERS_LABEL,
} from '@constants/data-page';
import MetadataFilters from '@components/metadataFilters/MetadataFilters';
import styles from './drawerMetadataFilters.module.scss';

interface IDrawerMetadataFiltersProps {
  openMetadataFilters: boolean;
  setOpenMetadataFilters: (open: boolean) => void;
  showClearAllMetadataFiltersButton: () => boolean;
  onClearAllFilters: () => void;
  showApplyMetadataFiltersButton: () => boolean;
  onClickApplyMetadataFilters: () => void;
  pipelineName: string;
  dataTestId?: string;
}

const DrawerMetadataFilters = ({
  openMetadataFilters,
  setOpenMetadataFilters,
  showClearAllMetadataFiltersButton,
  onClearAllFilters,
  showApplyMetadataFiltersButton,
  onClickApplyMetadataFilters,
  pipelineName,
  dataTestId,
}: IDrawerMetadataFiltersProps) => {
  // When the user clears all filters, we also need to clear the filters from the URL
  const handleClearAll = () => {
    onClearAllFilters();
    updateURLParamsSilently(new URLSearchParams());
  };

  return (
    <Drawer
      title={METADATA_FILTERS_LABEL}
      onClose={() => setOpenMetadataFilters(false)}
      open={openMetadataFilters}
      extra={
        <Space>
          {showClearAllMetadataFiltersButton() && (
            <Button onClick={handleClearAll}>{METADATA_FILTERS_CLEAR_ALL_LABEL}</Button>
          )}
          {showApplyMetadataFiltersButton() && (
            <Button onClick={onClickApplyMetadataFilters} type="primary">
              {METADATA_FILTERS_APPLY_LABEL}
            </Button>
          )}
        </Space>
      }
      className={styles.metadataFiltersDrawer}
      data-testid={dataTestId}
    >
      <MetadataFilters pipelineName={pipelineName} showAll />
    </Drawer>
  );
};

export default DrawerMetadataFilters;
